export const sideBarTitle = 'Admin Panel';
